import { useState, useCallback } from 'react';
import { postCloneMultipleSectionsURL } from "../../utils/ConstantsURL";

export const useCloneMultipleSections = () => {
    const [loadingMultiple, setLoadingMultiple] = useState(false);

    const executeMultipleClone = useCallback(async (token, params) => {
        if (loadingMultiple) return { success: false, error: "Operación en curso, por favor espere." };

        setLoadingMultiple(true);
        try {
            const fullUrl = postCloneMultipleSectionsURL();
            
            const payload = {
                originDocumentId: Number(params.originDocumentId),
                targetDocumentId: Number(params.targetDocumentId),
                targetSectionId: Number(params.targetSectionId),
                sources: params.sources,
                date: params.date
            };

            console.log("Enviando Payload a Backend (Multiple Sources):", payload);

            const response = await fetch(fullUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(payload)
            });

            const contentType = response.headers.get("content-type");
            let data = {};
            
            if (contentType && contentType.includes("application/json")) {
                data = await response.json();
            }

            if (!response.ok) {
                throw new Error(data.error || data.message || `Error del servidor: ${response.status}`);
            }

            if (response.status === 207) {
                return { success: true, partial: true, data };
            }

            return { success: true, partial: false, data };

        } catch (err) {
            console.error("Error en useCloneMultipleSections:", err.message);
            return { success: false, error: err.message };
        } finally {
            setLoadingMultiple(false);
        }
    }, [loadingMultiple]);

    return { executeMultipleClone, loadingMultiple };
};
